import { gql } from '@apollo/client';

export const FR_ASSEMBLY_FIELDS = gql`
    fragment fr_AssemblyFields on Assembly {
        AssemblyId
        Code
        Component {
            ComponentId
        }
        Created
        Name
        sv_name: Name(LangCode: SV)
        en_name: Name(LangCode: EN)
        no_name: Name(LangCode: NO)
        ServiceWork {
            Name
            ServiceWorkId
        }
        Updated
    }
`;
